import React, { useState } from 'react';
import { Container, Row, Col, Card, ProgressBar } from 'react-bootstrap';
import './SupplierOnboarding.css';

const SupplierOnboarding = () => {
  const [selectedStage, setSelectedStage] = useState('initial');

  const workflowStages = [
    {
      id: 'initial',
      title: 'Initial Registration',
      icon: 'bi-pencil-square',
      checklist: [
        { task: 'Basic Company Information', status: 'Automated validation', completed: true },
        { task: 'Business Registration', status: 'Document verification', completed: true },
        { task: 'Tax Information', status: 'Pending verification', completed: false },
      ]
    },
    {
      id: 'vetting',
      title: 'Automated Vetting',
      icon: 'bi-shield-check',
      checklist: [
        { task: 'Credit Check', status: 'Automated check complete', completed: true },
        { task: 'Compliance Verification', status: 'In progress', completed: false },
        { task: 'Risk Assessment', status: 'Scheduled', completed: false },
      ]
    },
    {
      id: 'documentation',
      title: 'Documentation',
      icon: 'bi-file-earmark-text',
      checklist: [
        { task: 'Legal Documents', status: 'Awaiting upload', completed: false },
        { task: 'Certifications', status: 'Processing', completed: false },
        { task: 'Insurance Proof', status: 'Verified', completed: true },
      ]
    },
    {
      id: 'monitoring',
      title: 'Continuous Monitoring',
      icon: 'bi-graph-up',
      checklist: [
        { task: 'Performance Metrics', status: 'Active monitoring', completed: true },
        { task: 'Compliance Updates', status: 'Scheduled checks', completed: true },
        { task: 'Risk Indicators', status: 'Real-time monitoring', completed: true },
      ]
    }
  ];

  const monitoringMetrics = [
    {
      title: 'Active Verifications',
      value: '28',
      icon: 'bi-shield-check',
      trend: '+5 this week'
    },
    {
      title: 'Average Vetting Time',
      value: '3.2d',
      icon: 'bi-clock-history',
      trend: '-0.5d improvement'
    },
    {
      title: 'Success Rate',
      value: '94%',
      icon: 'bi-graph-up',
      trend: '+2.1% this month'
    },
    {
      title: 'Compliance Score',
      value: '4.8',
      icon: 'bi-award',
      trend: 'Above target'
    }
  ];

  const recentAlerts = [
    {
      type: 'warning',
      title: 'Pending Documentation',
      description: '3 suppliers awaiting document verification',
      time: '2 hours ago'
    },
    {
      type: 'success',
      title: 'Vetting Complete',
      description: 'Tech Solutions Inc. passed all verification checks',
      time: '4 hours ago'
    },
    {
      type: 'danger',
      title: 'Compliance Alert',
      description: 'Updated regulation requires additional verification',
      time: '1 day ago'
    }
  ];

  return (
    <div className="page-container">
      <Container>
        <div className="page-header">
          <h1>Supplier Onboarding Tools</h1>
          <p className="lead">Automated vetting and continuous monitoring system</p>
        </div>

        <div className="onboarding-workflow">
          {workflowStages.map((stage, index) => (
            <Card 
              key={stage.id}
              className="workflow-stage"
              onClick={() => setSelectedStage(stage.id)}
            >
              <div className="stage-header">
                <div className="stage-number">{index + 1}</div>
                <i className={`bi ${stage.icon} stage-icon`}></i>
                <h4>{stage.title}</h4>
              </div>
              <ul className="checklist-items">
                {stage.checklist.map((item, idx) => (
                  <li key={idx} className="checklist-item">
                    <i className={`bi ${item.completed ? 'bi-check-circle-fill' : 'bi-circle'} checklist-icon`}></i>
                    <div className="checklist-content">
                      <div>{item.task}</div>
                      <small className="checklist-status">{item.status}</small>
                    </div>
                  </li>
                ))}
              </ul>
            </Card>
          ))}
        </div>

        <Row>
          <Col lg={8}>
            <Card className="monitoring-section">
              <Card.Body>
                <h4>Vetting Progress</h4>
                <div className="monitoring-grid">
                  {monitoringMetrics.map((metric, index) => (
                    <Card key={index} className="monitoring-card text-center">
                      <Card.Body>
                        <i className={`bi ${metric.icon} monitoring-icon`}></i>
                        <div className="monitoring-metric">{metric.value}</div>
                        <div className="metric-label">{metric.title}</div>
                        <small className="text-muted">{metric.trend}</small>
                      </Card.Body>
                    </Card>
                  ))}
                </div>

                <div className="vetting-progress">
                  <div className="progress-header">
                    <h5>Overall Vetting Progress</h5>
                    <span>75% Complete</span>
                  </div>
                  <ProgressBar>
                    <ProgressBar variant="success" now={40} />
                    <ProgressBar variant="info" now={20} />
                    <ProgressBar variant="warning" now={15} />
                  </ProgressBar>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={4}>
            <Card className="alert-section">
              <Card.Body>
                <h4>Recent Alerts</h4>
                <div className="alert-list">
                  {recentAlerts.map((alert, index) => (
                    <div key={index} className="alert-item">
                      <i className={`bi bi-exclamation-circle alert-icon ${alert.type}`}></i>
                      <div className="alert-content">
                        <h5 className="alert-title">{alert.title}</h5>
                        <p className="alert-description">{alert.description}</p>
                        <small className="text-muted">{alert.time}</small>
                      </div>
                    </div>
                  ))}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SupplierOnboarding;
